<template>
  <v-container>
    <v-card>
      <v-card-title>
        Add position
        <v-icon right>fa-map-marker-alt</v-icon>
      </v-card-title>
      <v-card-subtitle>
        <p>
          From main menu: Pilots or on change status to
          <v-chip color="orange" small>LANDED</v-chip>.
          <kbd>See previous help "Sign In - Landed - Exit"</kbd>
        </p>
        <v-row>
          <v-col cols="6">
            <v-img :src="AddPosHelp1" height="300px" aspect-ratio="1" contain></v-img>
          </v-col>
          <v-col cols="6">
            <p>
              <v-icon x-small>fa-lightbulb</v-icon>
              <i>Help buttons - directs to this help.</i>
            </p>
            <p>
              <v-icon x-small>fa-lightbulb</v-icon>
              <i>Layers - show different maplayers.</i>
            </p>
            <p>
              <v-icon x-small>fa-lightbulb</v-icon>
              <i>
                Geolocation -
                <kbd>See below "Using Geolocation"</kbd>.
              </i>
            </p>
            <!-- <v-list-item>
              <v-list-item-content>
                <v-list-item-title></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>-->
          </v-col>
        </v-row>
        <p>
          1: Zoom to your position. Push the
          <v-chip x-small color="primary">ADD POSITION</v-chip>button.
        </p>
        <v-row>
          <v-col cols="6">
            <v-img :src="AddPosHelp2" height="300px" aspect-ratio="1" contain></v-img>
            <!-- </v-col>
            <v-col cols="3">-->
            <v-img :src="AddPosHelp3" height="300px" aspect-ratio="1" contain></v-img>
          </v-col>
          <v-col cols="6">
            <p>
              <v-icon x-small>fa-lightbulb</v-icon>
              <i>
                Before save - you can use the
                <v-chip x-small color="primary">
                  <v-icon x-small>fa-trash</v-icon>
                </v-chip>button to remove the marker.
              </i>
            </p>
            <p>
              <v-icon x-small>fa-lightbulb</v-icon>
              <i>Under Details you'll find the markers coordinates.</i>
            </p>
          </v-col>
        </v-row>

        <p>2: Save position.</p>
        <v-row>
          <v-col cols="6">
            <v-img :src="AddPosHelp4" height="300px" aspect-ratio="1" contain></v-img>
          </v-col>
          <v-col cols="6">
            <p>
              <v-icon x-small>fa-lightbulb</v-icon>
              <i>You may drag the marker to a more exact location before saving.</i>
            </p>
            <p>
              <v-icon x-small>fa-lightbulb</v-icon>
              <i>Other pilots who have saved their position, are marked with a red circle.</i>
            </p>
            <p>
              <v-icon x-small>fa-lightbulb</v-icon>
              <i>It is better to use the map at Main menu "Box Map" to see where other pilots are.</i>
            </p>
          </v-col>
        </v-row>
        <p>To add a new position - just repeat the steps above.</p>
      </v-card-subtitle>
    </v-card>
    <v-card>
      <v-card-title>
        Using Geolocation
        <v-icon right>fa-smile-wink</v-icon>
      </v-card-title>
      <v-card-subtitle>
        <p>If you are not quite sure or don't know where you are - you can try the Geolocation service.</p>
        <p>
          Geolocation uses different sources to decide your position. First of all the GPS in your mobile device. To enhance the precision,
          open a mobile app which uses GPS, for instance Google map or the Help 113 app in advance.
          PG Box is a Web app - so it depends on the browser app you are using. 
          Usually you will be asked to allow pgbox to use geolocation. 
          You can set the behaviour "ask/allow/deny" from your mobiles settings menu. 
          </p>
        <!-- <p>Enable location service in:</p>
        <a
                    href="https://www.wikihow.com/Enable-Location-Services-on-Google-Chrome"
                    target="_blank"
                     ><v-chip
                      color="primary"
                      rounded
                      small
                      >Google Chrome
                      <v-icon small right>mdi-map</v-icon>
                    </v-chip></a>
                    <a
                    href="https://support.microsoft.com/en-us/microsoft-edge/location-and-privacy-in-microsoft-edge-31b5d154-0b1b-90ef-e389-7c7d4ffe7b04#:~:text=To%20allow%20Microsoft%20Edge%20to%20share%20your%20location,a%20website%20wants%20to%20access%20your%20precise%20location."
                    target="_blank"
                     ><v-chip
                      color="primary"
                      rounded
                      small
                      >Edge
                      <v-icon small right>mdi-map</v-icon>
                    </v-chip></a> -->

        <v-row>
          <v-col cols="6">
            <v-img :src="AddPosHelp5" height="300px" aspect-ratio="1" contain></v-img>
          </v-col>
          <v-col cols="6">
            <p>
              Push the Geolocation button
              <v-chip small>
                <v-icon x-small color="orange">fa-map-marker</v-icon>
              </v-chip>
            </p>
            <p>
              <!-- <v-icon x-small>fa-lightbulb</v-icon> -->
              <i>The browser app will first ask for permission to use Geolocation.</i>
            </p>
            <p>
              <v-icon x-small>fa-lightbulb</v-icon>
              <i>The location service depend on wich browser app you use and the location settings in the app.</i>
            </p>
            <p>
              1: Zoom, adjust to your probable position. Push the
              <v-chip x-small color="primary">ADD POSITION</v-chip>button.
            </p>
            <p>2: Save position.</p>
          </v-col>
        </v-row>
      </v-card-subtitle>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      HelpLsb1: require("@/assets/HelpLsb1.png"),
      AddPosHelp1: require("@/assets/AddPosHelp1.png"),
      AddPosHelp2: require("@/assets/AddPosHelp2.png"),
      AddPosHelp3: require("@/assets/AddPosHelp3.png"),
      AddPosHelp4: require("@/assets/AddPosHelp4.png"),
      AddPosHelp5: require("@/assets/AddPosHelp5.png")
    };
  }
};
</script>
